import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import { BookingsToEditSortColumn, BookingsToEditSortDirection } from 'store/bookingsFilterSlice';

interface SortableBookingTableHeaderProps {
  column: BookingsToEditSortColumn;
  label: string;
  currentSortColumn: BookingsToEditSortColumn;
  sortDirection: BookingsToEditSortDirection;
  onSort: (column: BookingsToEditSortColumn) => void;
  align?: 'left' | 'center' | 'right';
}

export default function SortableBookingTableHeader({
  column,
  label,
  currentSortColumn,
  sortDirection,
  onSort,
  align = 'left',
}: SortableBookingTableHeaderProps) {
  const isActive = currentSortColumn === column;

  return (
    <TableCell
      align={align}
      sx={{
        borderBottom: 'none',
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <TableSortLabel
        active={isActive}
        direction={isActive ? sortDirection : 'asc'}
        onClick={() => onSort(column)}
        sx={{
          '&:hover': {
            color: 'inherit',
          },
          '&.Mui-active': {
            color: 'inherit',
            '& .MuiTableSortLabel-icon': {
              opacity: 1,
            },
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
